import { Ng2StateDeclaration } from '@uirouter/angular';
import { ValidationGlobalStore } from 'src/app/utilities/validation/validation-global-store';
import { Validator } from 'src/app/utilities/validation/validation.interfaces';
import { ValidatorStoreBase } from 'src/app/utilities/validation/validator-store-base';
import { ClientJourneyContext } from '../services/deal/client-journey-context';
import { ClientJourneyValidationMetadata } from './client-journey-validation-metadata';

export abstract class ClientJourneyValidatorStoreBase extends ValidatorStoreBase<Validator> {
  private slideState: Ng2StateDeclaration;

  constructor(
    globalStore: ValidationGlobalStore,
    protected readonly clientJourneyContext: ClientJourneyContext,
    menuStateName: string,
  ) {
    super(globalStore);

    let menuService = clientJourneyContext.menuService;
    let slideStates = menuService.getSlideSates();
    this.slideState = slideStates.find(s => s.name == menuStateName);
  }

  protected override isValidStateChanged(): void {
    if (!this.slideState) return;

    let invalidRules = this.getInvalidRules();
    let metadata: ClientJourneyValidationMetadata[] = invalidRules.map(
      r => r.metadata,
    );
    let showInvalidMenuState = metadata.some(m => m.showInMenu);
    this.slideState.data.isValid = !showInvalidMenuState;
  }
}
